"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- INLINEMESSAGE : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'InContentMessage',
  group: _definitionhelpers.groupNames.messages,
  props: {}
};
exports.default = _default;